module.exports = __webpack_public_path__ + "static/media/logo.886606fa.png";